import { render, staticRenderFns } from "./sp-list.vue?vue&type=template&id=882a6dbc&scoped=true&"
import script from "./sp-list.vue?vue&type=script&lang=ts&"
export * from "./sp-list.vue?vue&type=script&lang=ts&"
import style0 from "./sp-list.vue?vue&type=style&index=0&id=882a6dbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882a6dbc",
  null
  
)

export default component.exports